import { getVertexId } from '../../core/util';
import type { CoreTypes } from '../../core';
import type { Types as SduiTypes } from '../types';
import { toISOString } from '../../common/functions';

export default (
  exception: CoreTypes.Mixed.Exception,
  options:   SduiTypes.options
): SduiTypes.holiday => {
  return {
    id:        getVertexId(exception, options),
    name:      exception.description ?? '',
    begins_at: toISOString(exception.start)!,
    ends_at:   toISOString(exception.end)!,
  };
};
